<template>
	<div class="fater-body-show">
        <Row :gutter="15">
            <Col span="8">
                 <div class="fater-calendar-panel">
                    <Calendar cell-height="40"/>
                </div>
            </Col>
            <Col span="16">
                <Card>
                    <template #title>
                        系统信息
                    </template>
                    <div>
                        <div class="fater-sysinfo-panle">
                            <table>
                                <tr>
                                    <td>系统名称</td>
                                    <td>校园自习室管理系统(杜老师)</td>
                                </tr>
                                <tr>
                                    <td>运行环境</td>
                                    <td>JDK17 + NodeJS v20.11.1 + MySQL 8.0.26</td>
                                </tr>
                                <tr>
                                    <td>客户端开发</td>
                                    <td>Vue3.0 + Vue-Router4.1.6 + VueX4.1.0 + view-ui-plus1.1.39</td>
                                </tr>
                                <tr>
                                    <td>服务端开发</td>
                                    <td>SpringBoot3.3.4 + MyBatisPlus5.5</td>
                                </tr>
                                <tr>
                                    <td>开发时间</td>
                                    <td>2024-10-07</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </Card>
            </Col>
        </Row>
        <Row :gutter="15">
            <Col span="8">
                <Card>
                    <template #title>
                        自习室使用
                    </template>
                    <!-- 为自习室使用情况统计图表 准备一个具备大小（宽高）的Dom -->
                    <div ref="barUseVsFree" style="width: 100%;height: 300px;"></div>
                </Card>
                <Card>
                    <template #title>
                        学生状态
                    </template>
                    <div ref="barNormalVsBlack" style="width: 100%;height: 300px;"></div>
                </Card>
            </Col>
            <Col span="16">
                <Card>
                    <template #title>
                        本月每日座位使用情况
                    </template>
                    <div ref="lineUseSeat" style="width: 100%;height: 300px;"></div>
                </Card>
                <Card>
                    <template #title>
                        本月每日座位预约情况
                    </template>
                    <div ref="lineMakeSeat" style="width: 100%;height: 300px;"></div>
                </Card>
            </Col>
        </Row>   
    </div>
</template>

<style></style>

<script>
import {
    getDayStatisSeatUSeVSFree,
    getMonthStatisSeatUse,
    getMonthStatisSeatMake,
    getDayStatisStuNormalVSBlack,
} from '../../api/index.js';
import * as echarts from "echarts";
export default{
    data(){
        return {
            useSeatData: {
                items: [],
                vals: []
            },
            makeSeatData: {
                items: [],
                vals: []
            },
            daySeatUSeVSFreeData: [],
            dayStuNormalVSBlack: [],
        }
    },
    methods: {
        drawLineSeatUse(){
            // 基于准备好的dom，初始化echarts实例
            let lineUseSeat = echarts.init(this.$refs.lineUseSeat);
            // 定义折线图的配置项
            lineUseSeat.setOption({
                xAxis: {
                    type: 'category',
                    data: this.useSeatData.items
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: this.useSeatData.vals,
                        type: 'line',
                        // 是否显示平滑曲线
                        smooth: true
                    }
                ]
            });
        },
        drawLineSeatMake(){
            let lineMakeSeat = echarts.init(this.$refs.lineMakeSeat);
            lineMakeSeat.setOption({
                xAxis: {
                    type: 'category',
                    data: this.makeSeatData.items
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: this.makeSeatData.vals,
                        type: 'line',
                        smooth: true
                    }
                ]
            });
        },
        drawBarSeatUseVSFree(){
            // 基于准备好的dom，初始化echarts实例
            let barUseVsFree = echarts.init(this.$refs.barUseVsFree);
            // 定义了饼图的配置项
            barUseVsFree.setOption({
                // 鼠标悬浮提示
                tooltip: {
                    trigger: 'item'
                },
                // 图例位置 页面顶部距离为5%，左右居中。
                legend: {
                    top: '5%',
                    left: 'center'
                },
                series: [{
                    type: 'pie',
                    // 内外半径
                    radius: ['40%', '70%'],
                    // 避免标签重叠的属性 设置为false
                    avoidLabelOverlap: false,
                    // 定义了饼图每一块的样式，包括圆角、边框颜色和宽度。
                    itemStyle: {
                        borderRadius: 10,
                        borderColor: '#fff',
                        borderWidth: 2
                    },
                    // 设置了不显示标签，但是为了显示圆环，设置了位置居中。
                    label: {
                        show: false,
                        position: 'center'
                    },
                    // 定义了饼图中鼠标悬停时的样式，让标签显示为粗体并设置字号为25px。
                    emphasis: {
                        label: {
                        show: true,
                        fontSize: 25,
                        fontWeight: 'bold'
                        }
                    },
                    // 设置了不显示标签视觉引导线。
                    labelLine: {
                        show: false
                    },
                    // 设置了饼图的数据
                    data: this.daySeatUSeVSFreeData  
                }]
            });
        },
        drawBarStuNormalVSBlack(){
            let barNormalVsBlack = echarts.init(this.$refs.barNormalVsBlack);
            barNormalVsBlack.setOption({
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    top: '5%',
                    left: 'center'
                },
                series: [{
                    type: 'pie',
                    radius: ['40%', '70%'],
                    avoidLabelOverlap: false,
                    itemStyle: {
                        borderRadius: 10,
                        borderColor: '#fff',
                        borderWidth: 2
                    },
                    label: {
                        show: false,
                        position: 'center'
                    },
                    emphasis: {
                        label: {
                        show: true,
                        fontSize: 25,
                        fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: this.dayStuNormalVSBlack  
                }]
            });
        },
    },
    mounted(){
        getMonthStatisSeatUse().then(resp =>{
            resp.data.forEach(item =>{
                this.useSeatData.items.push(item.day);
                this.useSeatData.vals.push(item.total);
            })
            this.drawLineSeatUse();
        });
        getMonthStatisSeatMake().then(resp =>{
            resp.data.forEach(item =>{
                this.makeSeatData.items.push(item.day);
                this.makeSeatData.vals.push(item.total);
            })
            this.drawLineSeatMake();
        });
        getDayStatisSeatUSeVSFree().then(resp =>{
            this.daySeatUSeVSFreeData = [
                { value: resp.data.useTotal, name: "使用位置"},
                { value: resp.data.freeTotal, name: "空闲位置"},
            ];
            this.drawBarSeatUseVSFree();
        });
        getDayStatisStuNormalVSBlack().then(resp =>{
            this.dayStuNormalVSBlack = [
                { value: resp.data.normal, name: "正常学生"},
                { value: resp.data.black, name: "限制学生"},
            ];
            this.drawBarStuNormalVSBlack();
        });
    }
}
</script>